export interface IMemberServedTimespan {
  end: null
  start: number
}
